import { render, staticRenderFns } from "./BCollectPointDetails.vue?vue&type=template&id=d0806f98&scoped=true&"
import script from "./BCollectPointDetails.vue?vue&type=script&lang=js&"
export * from "./BCollectPointDetails.vue?vue&type=script&lang=js&"
import style0 from "./BCollectPointDetails.vue?vue&type=style&index=0&id=d0806f98&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d0806f98",
  null
  
)

export default component.exports
import QForm from 'quasar/src/components/form/QForm.js';
import QCheckbox from 'quasar/src/components/checkbox/QCheckbox.js';
import QRadio from 'quasar/src/components/radio/QRadio.js';
import QSpace from 'quasar/src/components/space/QSpace.js';
import QDialog from 'quasar/src/components/dialog/QDialog.js';
import qInstall from "../../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(component, 'components', {QForm,QCheckbox,QRadio,QSpace,QDialog});
